import { Pipe, PipeTransform } from '@angular/core';
import { BmsLatestValue } from '@app/core/models/bms-latestvalue';

@Pipe({
  name: 'bmslorawanmetersgroupvalue'
})
export class BmsLorawanMetersGroupValuePipe implements PipeTransform {

  transform(values: BmsLatestValue[]): string {
    if (values && values.length > 0) {
      return values.map(x => x.value.toFixed((x.unit == 'm³' ? 3 : 1)) + ' ' + x.unit).join(',');
    }

    return '';
  }
}
